import { iosColors } from "mobile/components/IosParity";

/** Editorial industrial — bright logo-aligned orange/red accents. */
export const mx = {
  ...iosColors,
  ink: "#0F0F12",
  inkSoft: "#181A20",
  canvas: "#F7F8FA",
  surface: "#FFFFFF",
  muted: "#55575C",
  subtle: "#6E7278",
  accent: "#FF5C00",
  accentHover: "#E04F00",
  accentBright: "#FF8A1A",
  accentAmber: "#FFB000",
  accentRed: "#E60012",
  accentSoft: "rgba(255, 92, 0, 0.12)",
  accentSoftHero: "rgba(255, 138, 26, 0.24)",
  accentGlow: "rgba(255, 92, 0, 0.16)",
  hairline: "rgba(15, 15, 18, 0.1)",
  hairlineDark: "rgba(255, 255, 255, 0.14)",
  heroFade:
    "linear-gradient(180deg, rgba(15,15,18,0.55) 0%, rgba(15,15,18,0.28) 42%, rgba(15,15,18,0.82) 100%)",
  heroFadeTablet:
    "linear-gradient(105deg, rgba(15,15,18,0.78) 0%, rgba(15,15,18,0.28) 48%, rgba(15,15,18,0.62) 100%)",
  swoosh:
    "linear-gradient(90deg, #FFB000 0%, #FF5C00 35%, #FF1A1A 70%, #D70000 100%)",
  liftShadow: "0 24px 48px rgba(15,15,18,0.14)",
  fontMono: 'ui-monospace, "SF Mono", "Cascadia Code", monospace',
  tabletMax: 980,
  tabletBp: 700,
};

export function formatMoney(value, currency = "MXN", quoteLabel = "Cotización") {
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount <= 0) return quoteLabel;
  try {
    return new Intl.NumberFormat("es-MX", { style: "currency", currency }).format(amount);
  } catch {
    return `$${amount.toFixed(2)}`;
  }
}

export function resolvePrice(product) {
  const unitPrice = Number(product?.unitPrice);
  if (Number.isFinite(unitPrice) && unitPrice > 0) return product.unitPrice;
  const levels =
    product?.priceLevels && typeof product.priceLevels === "object" ? product.priceLevels : {};
  return levels.retail ?? levels.Retail ?? levels.RETAIL ?? product?.unitPrice;
}

export function normalizeTransmissions(raw) {
  const rows = raw?.data || raw || [];
  return (Array.isArray(rows) ? rows : [])
    .map((row) => row?.attributes?.name || row?.name || row?.label || "")
    .map((value) => String(value || "").trim())
    .filter(Boolean);
}
